module.exports = __webpack_public_path__ + "img/shenqing.eda4bf4a.png";